import type { MaskitoOptions, MaskitoPreprocessor } from '@maskito/core'

const LETTER = /[АВЕКМНОРСТУХABEKMHOPCTYX]/

const upperCasePreprocessor: MaskitoPreprocessor = ({ data, elementState }) => {
    const upperValue = elementState.value.toUpperCase()
    const upperData = data.toUpperCase()

    return {
        data: upperData,
        elementState: {
            selection: elementState.selection,
            value: upperValue,
        },
    }
}

export const standartCarNumberMask: MaskitoOptions = {
    mask: [LETTER, ' ', /\d/, /\d/, /\d/, ' ', LETTER, LETTER, ' ', /\d/, /\d/, /^\d?$/],
    preprocessors: [upperCasePreprocessor],
}

export const nonStandartCarNumberMask: MaskitoOptions = {
    mask: /./su,
    preprocessors: [upperCasePreprocessor],
}
